import { jsx as _jsx } from "react/jsx-runtime";
import { useInput } from "react-admin";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TimeZonePicker } from "./TimeZonePicker";
import { useTimeZoneService } from "./timeZoneService";
/**
 * Election > Data > Language, Date and Time: the election's timezone, one of
 * the event's configured zones. Empty uses the event primary, which the field
 * names; every area under the election uses this zone.
 */
export var ElectionTimeZoneInput = function (_a) {
    var context = _a.context, disabled = _a.disabled, _b = _a.source, source = _b === void 0 ? "presentation.timezone" : _b;
    var t = useTranslation().t;
    var service = useTimeZoneService();
    // A zone the event no longer configures can't be saved.
    var configuredOnly = function (value) {
        return typeof value === "string" && value && !context.configured.includes(value)
            ? t("lifecycle.settings.electionUnconfiguredSave")
            : undefined;
    };
    var field = useInput({ source: source, validate: configuredOnly }).field;
    var value = typeof field.value === "string" && field.value ? field.value : null;
    var primary = service.timeZoneOption(context.primary, service.text).label;
    // A zone the event no longer configures is shown, and the election uses the primary.
    var unconfigured = value !== null && !context.configured.includes(value);
    return (_jsx(Box, { sx: { width: "100%", minWidth: 0 }, children: _jsx(TimeZonePicker, { label: t("lifecycle.settings.electionZone"), value: value, zones: context.configured, primary: context.primary, clearable: true, disabled: disabled, placeholder: t("lifecycle.settings.electionPrimary", { zone: primary }), error: unconfigured, helperText: unconfigured
                ? t("lifecycle.settings.electionUnconfigured", { zone: primary })
                : t("lifecycle.settings.electionZoneHelp"), onChange: function (zone) { return field.onChange(zone); } }) }));
};
